import React from 'react'
import { checkTextTranslation, checkTranslation, getObject } from '../../utils/useful'
import FormViewer from '../FormViewer'

class AddressInput extends React.Component {
    state = {
        fields: [
            // { type: 'SelectInput', key: 'country', information: { label: '{{lang}}Country', address: 'getCountries', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Country', required: true }, showMain: true },
            { type: 'TextInput', key: 'zipCode', information: { label: '{{lang}}Zip Code', placeholder: '{{lang}}Zip Code', required: false } },
            { type: 'TextInput', key: 'address', information: { label: '{{lang}}Address', placeholder: '{{lang}}Address', required: false } },
            { type: 'TextInput', key: 'address2', information: { label: '{{lang}}Address 2', placeholder: '{{lang}}e.g. Suite #', required: false } },
            // { type: 'TextInput', key: 'city', information: { label: '{{lang}}City', placeholder: '{{lang}}City', required: true } },
            // {
            //     type: 'SelectInput', key: 'state', information: { label: '{{lang}}state', address: 'getStates', filter: { "country": '{{country}}' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}State', required: true  },
            //     dependencies: [{
            //         refKey: 'country', targetKey: 'state',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } } }, },
            //             effect: { show: true, changeHeader: [{ key: 'filter.country', value: '@data.country' }] }
            //         }],
            //         else: { show: true },
            //         init: true,

            //     }],
            //     showMain: true
            // },


        ]
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    componentDidMount() {
        // console.log('this.props.data', this.props?.data)
    }
    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {

    }
    liveChange = (data, init, key, value, extra, full) => {

        let helperKey = this.props.header?.information?.helperKey ? ('.' + this.props.header?.information?.helperKey) : ''
        this.props.changeValue((helperKey + key), value, this.props.extra)

    }

    getForm = () => {
        return this.form.getForm()
    }


    render() {
        let helperKey = this.props.header?.information?.helperKey ? ('.' + this.props.header?.information?.helperKey) : ''
        let data = {
            country: getObject(this.props.fullData, (helperKey + 'country')),
            state: getObject(this.props.fullData, (helperKey + 'state')),
            city: getObject(this.props.fullData, (helperKey + 'city')),
            zipCode: getObject(this.props.fullData, (helperKey + 'zipCode')),
            address: getObject(this.props.fullData, (helperKey + 'address')),
            address2: getObject(this.props.fullData, (helperKey + 'address2')),

        }



        return (
            <div className="w-100 "  >

                <FormViewer ref={el => this.form = el} liveChange={this.liveChange} initData={data} headers={this.state.fields} formClass={this.props.formClass} inputClass={this.props.inputClass} nopadding={true} noMargin={true} />

            </div>
        )
    }
}

export default AddressInput;